import {
  GET_STAFF_SERVICES_AND_MORE,
  GOT_STAFF_SERVICES_AND_MORE,
  GOT_CUSTOMERS_BASED_ON_FILTER,
  GET_CUSTOMERS_BASED_ON_FILTER,
  GET_SERVICE_RESOURCE_AVAILABILITY_DATES,
  GOT_SERVICE_RESOURCE_AVAILABILITY_DATES,
  GOT_PROFILE_FOR_CURRENT_USER,
  UPDATE_WAITLIST_STEP_DATA,
  SAVE_WAITLIST,
  SAVED_WAITLIST,
  SAVE_WAITLIST_ERROR,
} from "../actions/waitlist";
import {
  GOT_CUSTOMER_PROFILE_DATA,
  LIMITED_PERMISSIONS,
} from "../actions/customerProfile";
import { getLocationId } from "../utils/helpers";
import { UPDATED_GLOBAL_ERROR_MESSAGE } from "../actions/globalError";

import {
  waitlistStepInitialState,
  getEmptyCustomer,
} from "../state/initialState";
import objectAssign from "object-assign";
import { clone } from "./helper";
import { formatPhone } from "./../utils/helpers";
import moment from "moment";
import { union } from "lodash";

export default (state = waitlistStepInitialState, action) => {
  let clonedStepData;
  let clonedPermissions;
  switch (action.type) {
    case GET_CUSTOMERS_BASED_ON_FILTER:
      clonedStepData = clone(state.waitlistStepData);
      clonedStepData.loadingCustomersList = true;

      return objectAssign({}, state, { waitlistStepData: clonedStepData });

    case UPDATED_GLOBAL_ERROR_MESSAGE:
      clonedStepData = clone(state.waitlistStepData);
      clonedStepData.triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot = false; //this is here to avoid closing after an error when drag and drop happens
      return objectAssign({}, state, { waitlistStepData: clonedStepData });

    case GOT_PROFILE_FOR_CURRENT_USER:
      clonedPermissions = clone(state.limitedPermissions);

      (action.data.roles || []).forEach((role) => {
        if (role.name == "access-view-payment-info") {
          clonedPermissions.canCheckoutAllBookings = false;
        } else if (role.name == "access-view-all-cust") {
          clonedPermissions.canEditCustomerProfile = false;
        } else if (role.name === "access-view-calendar") {
          clonedPermissions.canEditAllBookings = false;
        }
      });
      //fix roles for edge cases
      if (
        action.data.roles &&
        !action.data.roles.find((role) => role.name == "service-provider")
      ) {
        // service provider can do anything
        if (
          !action.data.roles.find(
            (role) => role.name == "access-edit-payment-info"
          )
        ) {
          clonedPermissions.canCheckoutAllBookings = false;
        }
        if (
          !action.data.roles.find(
            (role) => role.name == "access-view-all-cust"
          ) &&
          !action.data.roles.find((role) => role.name == "access-edit-all-cust")
        ) {
          clonedPermissions.canCreateCustomerProfile = false;
        }
        if (
          !action.data.roles.find(
            (role) => role.name == "access-view-payment-info"
          ) &&
          !action.data.roles.find(
            (role) => role.name == "access-edit-payment-info"
          )
        ) {
          clonedPermissions.canViewAndEditCheckoutInvoicesForAllBookings = false;
        }
        if (
          !action.data.roles.find(
            (role) => role.name == "access-view-all-cust"
          ) &&
          !action.data.roles.find((role) => role.name == "access-edit-all-cust")
        ) {
          clonedPermissions.canSearchForCustomers = false;
        }
      }

      return objectAssign({}, state, {
        currentlyLoggedInUserid: action.data.id,
        roles: action.data.roles,
        limitedPermissions: clonedPermissions,
      });

    case LIMITED_PERMISSIONS:
      clonedPermissions = clone(state.limitedPermissions);
      let finalPermissions = objectAssign({}, clonedPermissions, action.data);
      return objectAssign({}, state, { limitedPermissions: finalPermissions });

    case GOT_CUSTOMER_PROFILE_DATA:
      clonedStepData = clone(state.waitlistStepData);
      clonedStepData.selectedCustomer.noShow = action.data.noshow;
      clonedStepData.address = action.data.address; // we update the address of the appointment with the customer address

      return objectAssign({}, state, { waitlistStepData: clonedStepData });

    case GOT_CUSTOMERS_BASED_ON_FILTER:
      clonedStepData = clone(state.waitlistStepData);
      let customerList =
        action.data &&
        action.data.customerlist &&
        action.data.customerlist.length > 0
          ? action.data.customerlist
          : [];

      customerList.map((o) => {
        if (o.phone) {
          o.phone = formatPhone(o.phone);
        }
        o.noShow = o.noshowcount;
      });

      clonedStepData.customerList = customerList;
      clonedStepData.loadingCustomersList = false;

      return objectAssign({}, state, { waitlistStepData: clonedStepData });

    case GET_STAFF_SERVICES_AND_MORE:
      return {
        ...state,
        finishedLoadingServicesAndOrganizationData: false,
      };
    case GOT_STAFF_SERVICES_AND_MORE:
      clonedPermissions = clone(state.limitedPermissions);
      clonedStepData = clone(state.waitlistStepData);

      if (!action || !action.data || !action.data.services) {
        console.error("bookingformfailed", JSON.stringify(action.data));
      }

      const locationId = getLocationId();
      action.data.locations
        .filter((loc) => loc.id == locationId)
        .map((loc) => {
          const locationResourceIds = loc.resources.map((r) => r.id);
          clonedStepData.staffList = action.data.resources.filter(
            (r) => !r.deleted && !r.hidden && locationResourceIds.includes(r.id)
          );

          const locationServiceIds = loc.services.map((s) => s.id);
          clonedStepData.serviceList = action.data.services.filter(
            (s) =>
              !s.deleted &&
              !s.hidden &&
              !s.offline &&
              locationServiceIds.includes(s.id) &&
              s.resources.some((r) => locationResourceIds.includes(r))
          );
        });

      action.data.services.map((o) => {
        o.duration = moment
          .utc(moment.duration(o.duration)._milliseconds)
          .format("HH:mm");
        if (o.availableduration) {
          o.availableduration = moment
            .utc(moment.duration(o.availableduration)._milliseconds)
            .format("HH:mm");
        }
        if (o.secondduration) {
          o.secondduration = moment
            .utc(moment.duration(o.secondduration)._milliseconds)
            .format("HH:mm");
        }
        if (o.bufferpostduration) {
          o.bufferpostduration = moment
            .utc(moment.duration(o.bufferpostduration)._milliseconds)
            .format("HH:mm");
        }
      });

      clonedStepData.organizationId = action.data.organizationid;
      clonedStepData.businessName = action.data.name;
      clonedStepData.paymentsEnabled = action.data.paymentsenabled;
      window.ORG_ID = action.data.organizationid; //TODO : REFACTOR THIS OUT ONCE WE HAVE RE-DONE THE CALENDAR
      const currentLocation = action.data.locations.find(
        (location) => location.id.toString() === locationId
      );
      const timezone =
        currentLocation && currentLocation.timezone
          ? currentLocation.timezone.id
          : action.data.timezone.id;
      clonedStepData.timezone = timezone;
      window.userTimezone = timezone;
      clonedStepData.doubleBookingEnabled = action.data.doublebookingenabled;
      clonedPermissions.displaystaffonline = action.data.displaystaffonline;
      clonedPermissions.displaynopreference = action.data.displaynopreference;
      if (
        clonedStepData.selectedStaff &&
        clonedStepData.selectedStaff.id &&
        clonedStepData.staffList &&
        clonedStepData.staffList.length > 0
      ) {
        //this is because sometimes the calendar will pass the staff and we store it inside selectedStaff.id before we get the details from the database
        clonedStepData.selectedStaff = clonedStepData.staffList.find(
          (x) => x.id == clonedStepData.selectedStaff.id
        );
      }
      if (
        clonedStepData.selectedService &&
        clonedStepData.selectedService.id &&
        clonedStepData.serviceList &&
        clonedStepData.serviceList.length > 0
      ) {
        //this is because sometimes the calendar will pass the service and we store it inside selectedService.id before we get the details from the database
        clonedStepData.selectedService = clone(
          clonedStepData.serviceList.find(
            (x) => x.id == clonedStepData.selectedService.id
          )
        ); // avoid updating the service of the list
      }

      return objectAssign({}, state, {
        waitlistStepData: clonedStepData,
        finishedLoadingServicesAndOrganizationData: true,
        businessCountryCode: action.data.address.countrycode,
        limitedPermissions: clonedPermissions,
      });

    case GET_SERVICE_RESOURCE_AVAILABILITY_DATES:
      clonedStepData = clone(state.waitlistStepData);
      clonedStepData.loadingServiceResourceAvaialbility = true;
      return objectAssign({}, state, { waitlistStepData: clonedStepData });

    case GOT_SERVICE_RESOURCE_AVAILABILITY_DATES:
      clonedStepData = clone(state.waitlistStepData);
      clonedStepData.loadingServiceResourceAvaialbility = false;
      if (action.payload.data.day) {
        clonedStepData.startTimes = union(
          clonedStepData.startTimes,
          action.data.starttimes
        );
        clonedStepData.finishTimes = union(
          clonedStepData.finishTimes,
          action.data.endtimes
        );
      } else {
        clonedStepData.bookingDates = action.data.bookingdates;
        clonedStepData.waitlistDates = action.data.waitlistdates;
        clonedStepData.closedDates = action.data.closeddates;
      }
      return objectAssign({}, state, { waitlistStepData: clonedStepData });

    case UPDATE_WAITLIST_STEP_DATA:
      return { ...state, waitlistStepData: action.data };

    case SAVE_WAITLIST:
      clonedStepData = objectAssign({}, state.waitlistStepData, {
        savingWaitlist: true,
        submitError: false,
        submitSuccess: false,
      });
      return objectAssign({}, state, { waitlistStepData: clonedStepData });

    case SAVED_WAITLIST:
      clonedStepData = objectAssign({}, state.waitlistStepData, {
        savingWaitlist: false,
        submitError: false,
        submitSuccess: true,
      });
      return objectAssign({}, state, { waitlistStepData: clonedStepData });

    case SAVE_WAITLIST_ERROR:
      clonedStepData = objectAssign({}, state.waitlistStepData, {
        savingWaitlist: false,
        submitSuccess: false,
        submitError: action.message,
      });
      return objectAssign({}, state, { waitlistStepData: clonedStepData });

    default:
      return state;
  }
};
